<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="880px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div v-loading="loading">
      <el-tabs
        v-model="selectedTab"
        tab-position="top"
      >
        <el-tab-pane
          label="Alapadatok"
          name="basicData"
        >
          <basic-data-form
            v-if="product"
            ref="basicData"
            :product="product"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Kiszerelések"
          name="packTypes"
        >
          <pack-types-form
            v-if="product && product.pack_types"
            ref="packTypes"
            :packTypes="product.pack_types"
            @packTypeChange="onPackTypeChange"
            @add="onPackTypeAdd"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Árak"
          name="prices"
        >
          <prices-form
            ref="prices"
            :product="product"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Összetevők"
          name="ingredients"
        >
          <ingredients-form
            v-if="product && product.ingredients"
            ref="ingredients"
            :ingredients="product.ingredients"
            @ingredientChange="onIngredientChange"
            @add="onIngredientAdd"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Képek"
          name="images"
        >
          <images-form
            v-if="product && product.images"
            ref="images"
            :images="product.images"
            @imageChange="onImageChange"
            @add="onImageAdd"
            @imageDelete="onImageDelete"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Fájlok"
          name="files"
        >
          <file-form
            v-if="product && product.files"
            ref="files"
            :files="product.files"
            @fileChange="onFileChange"
            @add="onFileAdd"
            @fileDelete="onFileDelete"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: space-between;"
    >
      <div>
        <el-alert
          v-if="buttonLoading && countAddedFiles > 2"
          type="info"
          :closable="false"
          style="margin-right: 10px; padding-left: 10px;"
        >
          <i class="el-icon-loading" style="font-weight: 600; font-size: 14px; margin-right: 5px;"></i> Termék feltöltése
          akár néhány percig is eltarthat.
        </el-alert>
      </div>
      <div>
        <el-button @click="handleClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          :loading="buttonLoading"
          @click="store"
        >
          {{ buttonText }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import BasicDataForm from './forms/BasicData';
  import PackTypesForm from './forms/PackTypes';
  import PricesForm from './forms/Prices';
  import IngredientsForm from './forms/Ingredients';
  import ImagesForm from './forms/Images';
  import FileForm from './forms/Files';

  export default {
    components: { BasicDataForm, PackTypesForm, PricesForm, IngredientsForm, ImagesForm, FileForm },
    props: ['type', 'productId'],
    data() {
      return {
        selectedTab: 'basicData',
        loading: false,
        buttonLoading: false,
        countAddedFiles: 0,
        product: {
          ctn: {},
          category: {},
          primary_supplier: {},
          manufacturer: {},
          pack_types: [],
          ingredients: [],
          images: [],
          files: [],
        },
        fileIdsToDelete: [],
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új termék';
        } else if (this.type === 'update') {
          return 'Termék módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    async mounted() {
      this.loading = true;
      await Promise.all([
        this.$store.dispatch('productCategory/fetchAll'),
        this.$store.dispatch('partner/fetchSuppliers'),
        this.$store.dispatch('manufacturer/fetchAll'),
        this.$store.dispatch('customsTariffNumber/fetchAll'),
        this.$store.dispatch('vat/fetchAll'),
        this.$store.dispatch('country/fetchAll'),
      ]);
      if (this.productId) {
        this.product = await this.$store.dispatch('product/fetch', this.productId);
      }
      this.loading = false;
    },
    methods: {
      onPackTypeAdd(packType) {
        this.product.pack_types.push(packType);
      },
      onPackTypeChange(packTypes) {
        this.product.pack_types = packTypes;
      },
      onIngredientAdd(ingredient) {
        this.product.ingredients.push(ingredient);
      },
      onIngredientChange(ingredients) {
        this.product.ingredients = ingredients;
      },
      onImageAdd(image) {
        this.product.images.push(image);
        this.countAddedFiles++;
      },
      onImageChange(images) {
        this.product.images = images;
      },
      onImageDelete(image) {
        if(!image.id) {
          this.countAddedFiles--;
        }
      },
      onFileAdd(file) {
        this.product.files.push(file);
        this.countAddedFiles++;
      },
      onFileChange(files) {
        this.product.files = files;
      },
      onFileDelete(file) {
        if (file.id) {
          this.fileIdsToDelete.push(file.id);
        } else {
          this.countAddedFiles--;
        }
      },
      handleClose() {
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/data/products');
        })
        .catch(() => {
        });
      },
      async store() {
        if (this.product.pack_types.length) {
          this.$refs['basicData'].$refs['basicDataForm'].validate(async valid => {
            if (valid) {
              const data = {
                ...this.$refs['basicData'].basicData,
                ...this.$refs['prices'].pricing,
                pack_types: this.product.pack_types,
                ingredients: this.product.ingredients,
                images: this.product.images,
              };
              this.buttonLoading = true;
              try {
                if (this.type === 'add') {
                  const response = await this.$store.dispatch('product/create', data);
                  await this.uploadFiles(response.id);
                  this.$messageWrapper.success('Termék sikeresen hozzáadva');
                } else if (this.type === 'update') {
                  const response = await this.$store.dispatch('product/update', data);
                  await this.uploadFiles(response.id);
                  await this.deleteFiles();
                  this.$messageWrapper.success('Termék sikeresen mòdosítva');
                }
                this.$store.dispatch('product/fetchAllWithPagination');
                this.buttonLoading = false;
                this.$router.replace('/data/products');
              } catch (e) {
              }
              this.buttonLoading = false;
            }
          });
        } else {
          this.selectedTab = 'packTypes';
          this.$messageWrapper.warning('Kiszerelés hozzáadása kötelező');
        }
      },
      async uploadFiles(productId) {
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        if (this.product.files.length) {
          for(let [idx, file] of this.product.files.entries()) {
            //  let promises = this.product.files.map(async file => {
            let formData = new FormData();
            formData.append('product_id', productId);
            formData.append('description', file.description || '');
            if (!file.id) {
              formData.append('file', file.source);
            }
            if (file.id) {
              formData.append('id', file.id);
            }
            await axios.post('api/file-upload', formData, config);
          }
         // });
          //await Promise.all(promises);
        }
      },
      async deleteFiles() {
        if (this.fileIdsToDelete.length) {
          return await axios.post('api/delete-files', { ids: this.fileIdsToDelete });
        }
      }
    }
  };
</script>
